// Scroll direction detection
(function() {
  let lastScrollTop = 0;
  let ticking = false;

  function updateScrollDirection() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(lastScrollTop - scrollTop) <= 5) {
      // Ignore small scroll movements to prevent jitter
      ticking = false;
      return;
    }

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      // Scrolling down and past threshold
      document.body.classList.add('scrolling-down');
    } else {
      // Scrolling up or at top
      document.body.classList.remove('scrolling-down');
    }

    lastScrollTop = scrollTop;
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateScrollDirection);
      ticking = true;
    }
  }

  // Use passive listener for better performance
  window.addEventListener('scroll', requestTick, { passive: true });

  // Initial check
  updateScrollDirection();
})();
